import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProductsPaginationService {

  private _scrollId = signal<string | null>(null);
  readonly scrollIdSignal = this._scrollId.asReadonly();

  // Computed signals for derived state
  readonly hasScrollId = computed(() => !!this._scrollId());
  readonly scrollIdValue = computed(() => this._scrollId());

  // Public setter methods for signals
  setScrollId(scrollId: string | null) {
    this._scrollId.set(scrollId);
  }

  clearScrollId() {
    this._scrollId.set(null);
  }

  // Legacy setter for backward compatibility
  set scrollId(scrollId: string) {
    if (scrollId) {
      this._scrollId.set(scrollId);
    }
  }
}
